import React from 'react';
import { Link } from 'react-router-dom';
import { CreditCardIcon, TruckIcon, ShieldIcon, MonitorIcon, DollarSignIcon, CoinsIcon, CircleDollarSignIcon } from 'lucide-react';
export const HomePage = () => {
  return <div className="w-full" data-id="element-446">
      {/* Hero Section */}
      <section className="bg-gradient-to-b from-green-50 to-white py-16 md:py-24" data-id="element-447">
        <div className="container mx-auto px-4" data-id="element-448">
          <div className="max-w-4xl mx-auto text-center" data-id="element-449">
            <h1 className="text-4xl md:text-6xl font-bold mb-6" data-id="element-450">
              <span className="text-gray-800" data-id="element-451">Premium </span>
              <span className="text-green-500" data-id="element-452">Electronics</span>
              <span className="text-gray-800" data-id="element-453"> & </span>
              <span className="text-amber-500" data-id="element-454">Precious Metals</span>
            </h1>
            <p className="text-gray-600 text-lg md:text-xl mb-8" data-id="element-455">
              Your trusted marketplace for high-quality used electronics and
              investment-grade precious metals. Currency-inspired design meets
              premium shopping experience.
            </p>
            <div className="flex flex-col sm:flex-row justify-center gap-4" data-id="element-456">
              <Link to="/shop?category=electronics" className="bg-green-500 text-white py-3 px-6 rounded-lg hover:bg-green-600 transition-colors shadow-sm" data-id="element-457">
                Shop Electronics
              </Link>
              <Link to="/shop?category=metals" className="bg-white text-green-500 border border-green-500 py-3 px-6 rounded-lg hover:bg-green-50 transition-colors shadow-sm" data-id="element-458">
                Browse Metals
              </Link>
            </div>
          </div>
        </div>
      </section>
      {/* Categories Section */}
      <section className="py-16" data-id="element-459">
        <div className="container mx-auto px-4" data-id="element-460">
          <h2 className="text-2xl md:text-3xl font-bold text-center mb-12" data-id="element-461">
            Shop by Category
          </h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-462">
            {/* Electronics Category */}
            <div className="bg-white rounded-xl shadow-sm overflow-hidden transition-transform hover:transform hover:scale-105" data-id="element-463">
              <Link to="/shop?category=electronics" className="block text-center p-6" data-id="element-464">
                <div className="bg-green-500 rounded-full h-16 w-16 flex items-center justify-center mx-auto mb-4" data-id="element-465">
                  <MonitorIcon size={32} className="text-white" data-id="element-466" />
                </div>
                <h3 className="text-xl font-semibold mb-2" data-id="element-467">Electronics</h3>
                <p className="text-gray-600" data-id="element-468">Laptops, phones, cameras & more</p>
              </Link>
            </div>
            {/* Gold Category */}
            <div className="bg-white rounded-xl shadow-sm overflow-hidden transition-transform hover:transform hover:scale-105" data-id="element-469">
              <Link to="/shop?category=gold" className="block text-center p-6" data-id="element-470">
                <div className="bg-amber-400 rounded-full h-16 w-16 flex items-center justify-center mx-auto mb-4" data-id="element-471">
                  <DollarSignIcon size={32} className="text-white" data-id="element-472" />
                </div>
                <h3 className="text-xl font-semibold mb-2" data-id="element-473">Gold</h3>
                <p className="text-gray-600" data-id="element-474">Bars, coins & jewelry</p>
              </Link>
            </div>
            {/* Silver Category */}
            <div className="bg-white rounded-xl shadow-sm overflow-hidden transition-transform hover:transform hover:scale-105" data-id="element-475">
              <Link to="/shop?category=silver" className="block text-center p-6" data-id="element-476">
                <div className="bg-gray-400 rounded-full h-16 w-16 flex items-center justify-center mx-auto mb-4" data-id="element-477">
                  <CoinsIcon size={32} className="text-white" data-id="element-478" />
                </div>
                <h3 className="text-xl font-semibold mb-2" data-id="element-479">Silver</h3>
                <p className="text-gray-600" data-id="element-480">Investment grade silver</p>
              </Link>
            </div>
            {/* Platinum Category */}
            <div className="bg-white rounded-xl shadow-sm overflow-hidden transition-transform hover:transform hover:scale-105" data-id="element-481">
              <Link to="/shop?category=platinum" className="block text-center p-6" data-id="element-482">
                <div className="bg-gray-700 rounded-full h-16 w-16 flex items-center justify-center mx-auto mb-4" data-id="element-483">
                  <CircleDollarSignIcon size={32} className="text-white" data-id="element-484" />
                </div>
                <h3 className="text-xl font-semibold mb-2" data-id="element-485">Platinum</h3>
                <p className="text-gray-600" data-id="element-486">Rare platinum items</p>
              </Link>
            </div>
          </div>
        </div>
      </section>
      {/* Featured Products */}
      <section className="py-16 bg-gray-50" data-id="element-487">
        <div className="container mx-auto px-4" data-id="element-488">
          <h2 className="text-2xl md:text-3xl font-bold text-center mb-12" data-id="element-489">
            Featured Products
          </h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-490">
            {/* Featured Product 1 */}
            <div className="bg-white rounded-xl shadow-sm overflow-hidden" data-id="element-491">
              <div className="p-4" data-id="element-492">
                <span className="inline-block bg-green-100 text-green-600 text-xs font-semibold px-2 py-1 rounded-full mb-3" data-id="element-493">
                  Featured Deal
                </span>
                <h3 className="font-semibold mb-1" data-id="element-494">MacBook Pro 2021</h3>
                <p className="text-sm text-gray-500 mb-3" data-id="element-495">
                  Refurbished - Excellent Condition
                </p>
                <div className="aspect-w-16 aspect-h-9 mb-4 flex items-center justify-center" data-id="element-496">
                  <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/pVpXANE4MPeUTAwYJSN7su/Screenshot_2025-08-06_at_07.25.36.png" alt="MacBook Pro" className="object-contain h-32 mx-auto" data-id="element-497" />
                </div>
                <div className="flex items-center justify-between mb-3" data-id="element-498">
                  <div data-id="element-499">
                    <span className="text-lg font-bold" data-id="element-500">$1,299</span>
                    <span className="text-sm text-gray-500 line-through ml-2" data-id="element-501">
                      $1,699
                    </span>
                  </div>
                  <span className="text-green-600 text-sm font-semibold" data-id="element-502">
                    -30% OFF
                  </span>
                </div>
                <button className="w-full bg-green-500 text-white py-2 rounded-lg hover:bg-green-600 transition-colors" data-id="element-503">
                  Add to Cart
                </button>
              </div>
            </div>
            {/* Featured Product 2 */}
            <div className="bg-white rounded-xl shadow-sm overflow-hidden" data-id="element-504">
              <div className="p-4" data-id="element-505">
                <span className="inline-block bg-amber-100 text-amber-600 text-xs font-semibold px-2 py-1 rounded-full mb-3" data-id="element-506">
                  Gold
                </span>
                <h3 className="font-semibold mb-1" data-id="element-507">Gold Bar 1oz</h3>
                <p className="text-sm text-gray-500 mb-3" data-id="element-508">
                  Investment Grade - 99.99% Pure
                </p>
                <div className="aspect-w-16 aspect-h-9 mb-4 flex items-center justify-center" data-id="element-509">
                  <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/oaU7AVpzGveQuccM4pJ9vy/Screenshot_2025-08-06_at_07.29.11.png" alt="Gold Bar" className="object-contain h-32 mx-auto" data-id="element-510" />
                </div>
                <div className="flex items-center justify-between mb-3" data-id="element-511">
                  <div data-id="element-512">
                    <span className="text-lg font-bold" data-id="element-513">$2,084</span>
                  </div>
                  <span className="text-amber-600 text-sm font-semibold" data-id="element-514">
                    Market Price
                  </span>
                </div>
                <button className="w-full bg-amber-500 text-white py-2 rounded-lg hover:bg-amber-600 transition-colors" data-id="element-515">
                  Add to Cart
                </button>
              </div>
            </div>
            {/* Featured Product 3 */}
            <div className="bg-white rounded-xl shadow-sm overflow-hidden" data-id="element-516">
              <div className="p-4" data-id="element-517">
                <span className="inline-block bg-blue-100 text-blue-600 text-xs font-semibold px-2 py-1 rounded-full mb-3" data-id="element-518">
                  Electronics
                </span>
                <h3 className="font-semibold mb-1" data-id="element-519">iPhone 14 Pro</h3>
                <p className="text-sm text-gray-500 mb-3" data-id="element-520">
                  Refurbished - Like New
                </p>
                <div className="aspect-w-16 aspect-h-9 mb-4 flex items-center justify-center" data-id="element-521">
                  <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/bngTbbaTJ7wdgAETVR58Qf/Screenshot_2025-08-06_at_07.30.39.png" alt="iPhone 14 Pro" className="object-contain h-32 mx-auto" data-id="element-522" />
                </div>
                <div className="flex items-center justify-between mb-3" data-id="element-523">
                  <div data-id="element-524">
                    <span className="text-lg font-bold" data-id="element-525">$899</span>
                    <span className="text-sm text-gray-500 line-through ml-2" data-id="element-526">
                      $999
                    </span>
                  </div>
                  <span className="text-blue-600 text-sm font-semibold" data-id="element-527">
                    -10% OFF
                  </span>
                </div>
                <button className="w-full bg-blue-500 text-white py-2 rounded-lg hover:bg-blue-600 transition-colors" data-id="element-528">
                  Add to Cart
                </button>
              </div>
            </div>
            {/* Featured Product 4 */}
            <div className="bg-white rounded-xl shadow-sm overflow-hidden" data-id="element-529">
              <div className="p-4" data-id="element-530">
                <span className="inline-block bg-purple-100 text-purple-600 text-xs font-semibold px-2 py-1 rounded-full mb-3" data-id="element-531">
                  Platinum
                </span>
                <h3 className="font-semibold mb-1" data-id="element-532">Platinum Bar 1oz</h3>
                <p className="text-sm text-gray-500 mb-3" data-id="element-533">
                  Investment Grade - 99.95% Pure
                </p>
                <div className="aspect-w-16 aspect-h-9 mb-4 flex items-center justify-center" data-id="element-534">
                  <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/oaU7AVpzGveQuccM4pJ9vy/Screenshot_2025-08-06_at_07.29.11.png" alt="Platinum Bar" className="object-contain h-32 mx-auto" data-id="element-535" />
                </div>
                <div className="flex items-center justify-between mb-3" data-id="element-536">
                  <div data-id="element-537">
                    <span className="text-lg font-bold" data-id="element-538">$1,054</span>
                  </div>
                  <span className="text-purple-600 text-sm font-semibold" data-id="element-539">
                    Market Price
                  </span>
                </div>
                <button className="w-full bg-purple-500 text-white py-2 rounded-lg hover:bg-purple-600 transition-colors" data-id="element-540">
                  Add to Cart
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Trust Badges Section */}
      <section className="py-16" data-id="element-541">
        <div className="container mx-auto px-4" data-id="element-542">
          <h2 className="text-2xl md:text-3xl font-bold text-center mb-12" data-id="element-543">
            Why Choose Us
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-544">
            <div className="text-center" data-id="element-545">
              <div className="bg-green-50 rounded-full h-16 w-16 flex items-center justify-center mx-auto mb-4" data-id="element-546">
                <CreditCardIcon size={32} className="text-green-500" data-id="element-547" />
              </div>
              <h3 className="text-xl font-semibold mb-2" data-id="element-548">Secure Payment</h3>
              <p className="text-gray-600" data-id="element-549">
                Your transactions are protected with industry-leading encryption
                and security measures.
              </p>
            </div>
            <div className="text-center" data-id="element-550">
              <div className="bg-green-50 rounded-full h-16 w-16 flex items-center justify-center mx-auto mb-4" data-id="element-551">
                <TruckIcon size={32} className="text-green-500" data-id="element-552" />
              </div>
              <h3 className="text-xl font-semibold mb-2" data-id="element-553">Fast Shipping</h3>
              <p className="text-gray-600" data-id="element-554">
                Get your products delivered quickly with our expedited shipping
                options.
              </p>
            </div>
            <div className="text-center" data-id="element-555">
              <div className="bg-green-50 rounded-full h-16 w-16 flex items-center justify-center mx-auto mb-4" data-id="element-556">
                <ShieldIcon size={32} className="text-green-500" data-id="element-557" />
              </div>
              <h3 className="text-xl font-semibold mb-2" data-id="element-558">Warranty</h3>
              <p className="text-gray-600" data-id="element-559">
                All electronics come with a 30-day warranty for peace of mind.
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>;
};